(() => {
 const dialog=document.getElementById('lumero-cookie-preferences');if(!dialog)return;
 const form=dialog.querySelector('form'),status=dialog.querySelector('[data-cookie-status]');
 let api,loading;
 const busy=value=>form.querySelectorAll('input,button').forEach(element=>element.disabled=value);
 function load(){
   if(window.Shopify?.customerPrivacy)return Promise.resolve(window.Shopify.customerPrivacy);
   if(loading)return loading;
   loading=new Promise((resolve,reject)=>{
     if(!window.Shopify?.loadFeatures){reject(Error('unavailable'));return;}
     const timeout=setTimeout(()=>reject(Error('timeout')),8000);
     window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{clearTimeout(timeout);if(error||!window.Shopify.customerPrivacy)reject(error||Error('unavailable'));else resolve(window.Shopify.customerPrivacy)});
   }).finally(()=>{loading=null});return loading;
 }
 document.addEventListener('click',async event=>{
   const trigger=event.target.closest('[data-cookie-preferences]');if(!trigger)return;
   event.preventDefault();
   if(window.privacyBanner?.showPreferences){try{await window.privacyBanner.showPreferences();return}catch{}}
   dialog.showModal();busy(true);status.textContent=dialog.dataset.loading;
   try{api=await load();const consent=api.currentVisitorConsent();form.querySelectorAll('input').forEach(input=>input.checked=consent[input.name]==='yes');status.textContent='';busy(false)}catch{status.textContent=dialog.dataset.error}
 });
 function save(rejectAll){
   if(!api)return;busy(true);status.textContent='';
   const choice=Object.fromEntries([...form.querySelectorAll('input')].map(input=>[input.name,rejectAll?false:input.checked]));
   const timeout=setTimeout(()=>{status.textContent=dialog.dataset.error;busy(false)},8000);
   try{api.setTrackingConsent(choice,()=>{clearTimeout(timeout);const stored=api.currentVisitorConsent();if(Object.entries(choice).every(([key,value])=>stored[key]===(value?'yes':'no'))){dialog.close();busy(false)}else{status.textContent=dialog.dataset.error;busy(false)}})}catch{clearTimeout(timeout);status.textContent=dialog.dataset.error;busy(false)}
 }
 form.addEventListener('submit',event=>{event.preventDefault();save(false)});dialog.querySelector('[data-cookie-reject]').addEventListener('click',()=>save(true));
})();
